import { useState } from 'react'
import styles from './TooltipGoftino.module.scss'
import Box from '@/components/UI/box/Box'

interface TooltipProps {
  text: string
}

const TooltipGoftino: React.FC<TooltipProps> = ({ text }) => {
  return (
    <Box className={styles['tooltip-container']}>
      <Box className={styles['tooltip']}>{text}</Box>
    </Box>
  )
}

export default TooltipGoftino
